module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-01-366d00f49e772171ba2d997fdb6067dd.jpg";